import React from 'react';
import {
  JUST_ONE_PAGE_FOOTER_LINK_LABEL,
  JUST_ONE_PAGE_FOOTER_URL,
} from '../justOnePageBrand';

export default function JustOnePageSiteFooter() {
  const linkStyle = { color: 'inherit', textDecoration: 'none' };

  return (
    <footer
      className="w-full py-8 px-4 text-center text-[11px] leading-relaxed"
      style={{ color: 'inherit', opacity: 0.55 }}
    >
      Fabriqué et hébergé par Just One Page module de{' '}
      <a
        href={JUST_ONE_PAGE_FOOTER_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline hover:underline"
        style={linkStyle}
      >
        {JUST_ONE_PAGE_FOOTER_LINK_LABEL}
      </a>
    </footer>
  );
}
